import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import Button from "components/Shared/CustomButtons/Button.js";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useDispatch, useSelector } from "react-redux";
import Category from "components/Admin/Categories/Category";
import { createCategory, getCompanies } from "store/actions/categories";

const CreateCategory = () => {
  const companies = useSelector((state) => state.categories.companies);
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCompanies(history));
  }, [history, dispatch]);

  const createHandler = (newData) => {
    dispatch(createCategory(newData, history));
  };

  return (
    <div>
      <div>
        <Button
          onClick={history.goBack}
          color="transparent"
          style={{ padding: 0 }}
        >
          <ArrowBackIcon style={{ width: "25px", height: "25px" }} />
          <h4 style={{ height: "25px", fontWeight: 900 }}>Back</h4>
        </Button>
      </div>
      <Card>
        <CardHeader color="primary">
          <h4>Create New Categories</h4>
        </CardHeader>
        <CardBody>
          {companies && (
            <Category
              companies={companies}
              category={null}
              isCreate={true}
              createHandler={createHandler}
              updateHandler={null}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default CreateCategory;
